import { parseISO } from 'date-fns';

import { Tour } from 'app/models/Tour';
import { ActiveContentState } from 'store/slices/activeContentSlice';

interface TourVisibilityOptions {
  tour: Tour;
  showPastTours: boolean;
  activeSearch: ActiveContentState['activeSearch'];
  todayStart: Date;
}

export const isTourVisible = ({
  tour,
  showPastTours,
  activeSearch,
  todayStart,
}: TourVisibilityOptions): boolean => {
  if (tour.direct) {
    return true;
  }

  if (activeSearch !== undefined) {
    return activeSearch.tourIds?.includes(tour.id) ?? false;
  }

  if (!showPastTours && parseISO(tour.date) < todayStart) {
    return false;
  }

  return !tour.delivered;
};
